import { listarRepsPrueba } from "./pruebaReps";

function celdaCsv(v) {
    const s = String(v ?? "");
    if (/[",\n\r]/.test(s)) {
        return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
}

function filaCsv(valores) {
    return valores.map(celdaCsv).join(",");
}

function formatoNumero(v) {
    if (v === null || v === undefined || v === "") return "";
    const n = Number(v);
    if (Number.isFinite(n)) return n;
    return v;
}

function aplicarMuestra(parametros, muestra) {
    if (!muestra || !Array.isArray(parametros)) return parametros ?? [];
    return parametros.map((p, i) => {
        const refM = muestra?.parametros?.[i];
        if (!refM) return { ...p };
        return {
            ...p,
            media: refM.valor,
            porcentaje: (Number(p.valor) / Number(refM.valor) - 1) * 100,
            dif: Number(p.valor) - Number(refM.valor),
        };
    });
}

function conjuntosParametros(pruebaDoc, { repIndex, parametrosOverride } = {}) {
    if (Array.isArray(parametrosOverride) && parametrosOverride.length > 0) {
        const reps = listarRepsPrueba(pruebaDoc);
        const rep = reps[repIndex] ?? reps[0];
        return [{ label: rep?.label ?? "Rep. 1", parametros: parametrosOverride }];
    }

    const reps = listarRepsPrueba(pruebaDoc);
    if (Array.isArray(pruebaDoc?.reps) && pruebaDoc.reps.length > 0) {
        return reps.map((r) => ({
            label: r.label,
            parametros: pruebaDoc.reps[r.index]?.parametros ?? [],
        }));
    }

    return [{ label: "Rep. 1", parametros: pruebaDoc?.parametros ?? [] }];
}

/**
 * CSV de parámetros de una prueba (todas las reps o solo la rep recalculada en pantalla).
 */
export function buildCsvParametros(pruebaDoc, opts = {}) {
    const { muestra, repIndex = 0, parametrosOverride } = opts;
    const conMuestra = Boolean(muestra);
    const conjuntos = conjuntosParametros(pruebaDoc, { repIndex, parametrosOverride });
    const variasReps = conjuntos.length > 1;

    const filas = [];
    const header = variasReps
        ? conMuestra
            ? ["Rep", "Parámetro", "Valor", "Unidad", "Muestra", "% diferencia", "Dif total"]
            : ["Rep", "Parámetro", "Valor", "Unidad"]
        : conMuestra
          ? ["Parámetro", "Valor", "Unidad", "Muestra", "% diferencia", "Dif total"]
          : ["Parámetro", "Valor", "Unidad"];

    filas.push(filaCsv(header));

    for (const { label, parametros } of conjuntos) {
        const params = aplicarMuestra(parametros, muestra);
        for (const p of params) {
            const base = [
                String(p.nombre ?? ""),
                formatoNumero(p.valor),
                String(p.u ?? ""),
            ];
            const extraMuestra = conMuestra
                ? [
                      formatoNumero(p.media),
                      Number.isFinite(Number(p.porcentaje))
                          ? Number(p.porcentaje).toFixed(2)
                          : "",
                      formatoNumero(p.dif),
                  ]
                : [];

            if (variasReps) {
                filas.push(filaCsv([label, ...base, ...extraMuestra]));
            } else {
                filas.push(filaCsv([...base, ...extraMuestra]));
            }
        }
    }

    if (filas.length <= 1) return null;
    return filas.join("\n");
}

export function blobCsvParametros(pruebaDoc, opts = {}) {
    const csv = buildCsvParametros(pruebaDoc, opts);
    if (!csv) return null;
    return new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8" });
}
